package pl.mothdigital.neuronowi.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.components.widgets.*

@Composable
fun SpecialistPageLayout(
    title: String,
    description: String? = null,
    ogImage: String? = null,
    contentAlignment: Alignment = Alignment.TopStart,
    headerSection: @Composable () -> Unit,
    profileSection: @Composable () -> Unit,
    specializationsSection: @Composable () -> Unit,
    servicesSection: @Composable () -> Unit,
    workAreasSection: @Composable (() -> Unit)? = null,
    howItWorksSection: @Composable (() -> Unit)? = null,
    priceSection: @Composable (() -> Unit)? = null,
    ctaSection: @Composable (PageContext) -> Unit,
) {
    val context = rememberPageContext()

    PageLayout(
        title = title,
        description = description,
        ogImage = ogImage,
        contentAlignment = contentAlignment,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            VerticalSpacer(78.px)

            headerSection()
            profileSection()
            workAreasSection?.invoke()
            specializationsSection()
            servicesSection()
            howItWorksSection?.invoke()
            priceSection?.invoke()
            ctaSection(context)
        }
    }
} 
